<template>
  <div :id="this._uid" style="display: none">
  </div>
</template>
<script type="text/babel">
  import GoogleMapChildren from './GoogleMapChildren'

  export default {
    name: 'GoogleMapPolyline',
    extends: GoogleMapChildren,
    watch: {


      positions(positions) {
        this.item.setPath(positions)
      }
    },
    methods: {
      init: function () {
        if (this.$parent.ready && this.item == null) {
          var self = this

          this.item = new google.maps.Polyline({
            path: self.positions,
            geodesic: true,
            strokeColor: self.color,
            strokeOpacity: 1.0,
            strokeWeight: 2
          })

          this.item.setMap(this.getMap())
        }
      }
    },
    props: {
      positions: {
        type: Array,
        required: true
      },
      color: {
        type: String,
        default: '#FF0000'
      },
    }
  }
</script>

<style>

</style>
